export default __webpack_public_path__ + "static/media/loader-review2.c41d99d6.svg";